module.exports = __webpack_public_path__ + "img/illustrator-login.50e74786.svg";